import useAuthority from "../../hooks/useAuthority";
import { AUTHORITY_TYPE } from "../../const";
import { useEffect, useMemo, useState } from "react";

const SelectRenderer = ({
  onChangeHandler,
  label,
  value,
  placeholder,
  options = [],
  noPlaceholder = false,
  form = "-",
  field = "-",
  module = "-",
  authenticated = false,
  editMode = false,
  disabled = false,
  searchable = false,
  style,
  ...props
}) => {
  const { view, authorized } = useAuthority({
    type: AUTHORITY_TYPE.FIELD,
    module: module,
    field: field,
    form: form,
    editMode: editMode,
    authenticated: authenticated,
  });

  const [currentValue, setCurrentValue] = useState(value);
  const [inputText, setInputText] = useState("");

  useEffect(() => {
    setCurrentValue(
      value === null || value === undefined || value === "" ? -1 : value
    );
  }, [value]);

  // whenever `value` changes externally, sync our inputText
  useEffect(() => {
    const opt = options.find((o) => o.value === value); //
    setInputText(opt ? opt.text : "");
    setCurrentValue(value);
  }, [value, options]);

  // build a quick map from label -> actual value
  const textToValue = useMemo(() => {
    return options?.reduce((m, o) => {
      m[o.text] = o.value;
      return m;
    }, {});
  }, [options]);

  if (searchable) {
    return (
      <>
        <input
          {...props}
          list={`datelist-${field}-${module}`}
          value={inputText}
          placeholder={placeholder}
          disabled={disabled || !authorized || !view}
          className="datalist-input"
          // clear on arrow-click or any mousedown when a value is present
          onMouseDown={() => {
            if (inputText) {
              setInputText("");
              setCurrentValue(undefined);
            }
          }}
          onChange={(e) => {
            const txt = e.target.value;
            setInputText(txt);

            // if they've typed an exact match, fire the change
            if (textToValue.hasOwnProperty(txt)) {
              const newVal = textToValue[txt];
              setCurrentValue(newVal);
              onChangeHandler(newVal);
            }
          }}
        />
        <datalist id={`datelist-${field}-${module}`}>
          {options?.map((o) => (
            <option key={o.key} value={o.text} />
          ))}
        </datalist>
      </>
    );
  } else {
    return (
      <select
        {...props}
        style={view ? style ?? {} : { display: "none" }}
        disabled={disabled || !authorized}
        className="ui dropdown"
        value={currentValue}
        onChange={(e) => {
          setCurrentValue(e.target.value);
          onChangeHandler(e.target.value);
        }}
      >
        {!noPlaceholder && currentValue === -1 && (
          <option value={-1} disabled selected>
            {placeholder}
          </option>
        )}
        {options?.map((option) => (
          <option key={option.key} value={option.value}>
            {option.text}
          </option>
        ))}
      </select>
    );
  }
};

export default SelectRenderer;